// Open Food / excess stock helpers for the POS screens (same rules as the web UI and the API).

/** A product sold with an editable description and rate (pr_isopen = '1', or named OPEN FOOD / OPEN ITEM) */
export const isOpenFoodProduct = (product: any): boolean => {
  if (!product) return false;
  const name = String(product.pr_name || '').toUpperCase();
  return String(product.pr_isopen) === '1' || name.includes('OPEN FOOD') || name.includes('OPEN ITEM');
};

/** Comparison key for descriptions: trim, collapse spaces, ignore case and accents */
export const descrKey = (s: any): string =>
  String(s ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

/** Cart key of a virtual excess-stock card */
export const excessCartKey = (prodId: number, descr: string): string => `ex:${prodId}:${descrKey(descr)}`;
